import React from 'react';
import { LogOut } from 'lucide-react';
import useProfile from '../hooks/useProfile';
import UserSection from './profile/UserSection';
import YourStandingCard from './profile/YourStandingCard';
import HouseholdSection from './profile/HouseholdSection';
import ArchivedChoresSection from './ArchivedChoresSection';

const Profile = ({ token, setToken, onUpdate, roommates = [], onLogout }) => {
    const payload = token ? JSON.parse(atob(token.split('.')[1])) : {};
    const hasHouse = !!payload.householdId;

    const {
        userData, loading,
        handleCreate, handleJoin, handleLeave, handleResetPin,
        handleUpdateProfile, handleUpdateHousehold, handleImageUpload,
    } = useProfile(token, setToken, onUpdate);

    if (loading) return <div className="p-8 text-center text-ink-fg/50">Loading Profile...</div>;
    return (
        <div className="max-w-md mx-auto space-y-4 pb-12">
            <UserSection userData={userData} onUpdate={handleUpdateProfile} onImageUpload={handleImageUpload} roommates={roommates} />

            {hasHouse && <YourStandingCard currentUserId={payload.userId} />}

            <HouseholdSection
                hasHouse={hasHouse}
                household={userData?.household}
                handleJoin={handleJoin}
                handleCreate={handleCreate}
                handleResetPin={handleResetPin}
                onUpdate={handleUpdateHousehold}
                onImageUpload={handleImageUpload}
            />

            {hasHouse && <ArchivedChoresSection onRestored={onUpdate} />}

            {/* Log out / Leave household */}
            <div className="pt-4">
                <div className="flex gap-2.5">
                    <button
                        onClick={onLogout}
                        className="flex-1 flex items-center justify-center gap-2 bg-ink-card2 text-ink-fg/70 font-bold py-3.5 rounded-2xl border border-white/10 hover:bg-ink-card3 transition-all active:scale-95"
                    >
                        <LogOut size={18} />
                        <span>Log out</span>
                    </button>
                    {hasHouse && (
                        <button
                            onClick={handleLeave}
                            className="flex-1 font-bold text-danger py-3.5 rounded-2xl border border-danger-border/25 hover:bg-danger/10 transition-all active:scale-95"
                        >
                            Leave household
                        </button>
                    )}
                </div>
                <p className="text-center text-[10px] font-mono text-ink-fg/25 mt-4 font-medium uppercase tracking-widest">
                    Schores v2.0 • Personal Beta
                </p>
            </div>
        </div>
    );
};

export default Profile;
